"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScrollDetect = /** @class */ (function () {
    function ScrollDetect(documentObject) {
        this.compactHeaderTop = 0;
        this.documentObject = documentObject;
        if (this.documentObject) {
            // Detect scroll to element and if scrolled
            var content_1 = documentObject.querySelector(".js-snap-header");
            var observer = new IntersectionObserver(function (_a) {
                var e = _a[0];
                return e.target.toggleAttribute('stuck', e.intersectionRatio < 1);
            }, { threshold: [1] });
            observer.observe(document.querySelector('.c-compact-header'));
            documentObject.addEventListener("scroll", function (event) {
                var body = documentObject.querySelector('body');
                var scrolled = documentObject.scrollingElement ? documentObject.scrollingElement.scrollTop : null;
                if (body == null)
                    return;
                if (scrolled && scrolled > 0) {
                    body.classList.add("is-scrolled");
                }
                else {
                    body.classList.remove("is-scrolled");
                }
                if (content_1) {
                    // Add class to body and element if scrolled to element
                    var position = content_1.offsetTop;
                    if (scrolled && scrolled > (position + 100)) {
                        body.classList.add('has-scrolled-to-element');
                        content_1.classList.add('is-scrolled-to-this-element');
                    }
                    else {
                        body.classList.remove('has-scrolled-to-element');
                        content_1.classList.remove('is-scrolled-to-this-element');
                    }
                }
            });
        }
    }
    return ScrollDetect;
}());
exports.default = ScrollDetect;
